import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

import { ExpanderDom, Header, Icon, Body, IconWrapper } from './Expander.Styles'
import { colors } from '../../constants'

class ExpanderComponent extends PureComponent {
    static propTypes = {
        header: PropTypes.node.isRequired,
        headerOpen: PropTypes.node,
        children: PropTypes.node,
        icon: PropTypes.string,
        bold: PropTypes.bool,
        disabled: PropTypes.bool,
        changeVisibility: PropTypes.func,
        isOpen: PropTypes.bool,
        onlyLeftChevron: PropTypes.bool,
        childrenHeight: PropTypes.number,
        onChangeHeight: PropTypes.func,
        color: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
        loading: PropTypes.bool,
        noAnimation: PropTypes.bool,
        noMargin: PropTypes.bool,
        noPropagation: PropTypes.bool,
        inTable: PropTypes.bool,
    }

    static defaultProps = {
        icon: null,
        bold: false,
        disabled: false,
        changeVisibility: null,
        isOpen: false,
        onlyLeftChevron: false,
        childrenHeight: 0,
        onChangeHeight: null,
        color: colors.bluedarkest,
        children: null,
        loading: null,
        noAnimation: false,
        noMargin: false,
        noPropagation: false,
        inTable: false,
    }

    state = {
        maxHeightBody: 0,
        isOpen: false,
    }

    changeVisibility = (e) => {
        const { disabled, changeVisibility, noPropagation } = this.props
        if (noPropagation && typeof e.stopPropagation === 'function') {
            e.stopPropagation()
        }

        const { isOpen } = this.state
        if (!disabled && changeVisibility) changeVisibility()
        if (!disabled) this.setState({ isOpen: !isOpen })
    }

    saveChildElement = (node) => {
        const { childrenHeight, onChangeHeight } = this.props
        const { maxHeightBody: prevMaxHeight } = this.state
        this.childElement = node
        if (this.childElement) {
            const maxHeightBody = this.childElement.scrollHeight + childrenHeight
            if (maxHeightBody !== prevMaxHeight) {
                this.setState({
                    maxHeightBody,
                })
                if (onChangeHeight) onChangeHeight(maxHeightBody)
            }
        }
    }

    renderHeader = () => {
        const { header, headerOpen } = this.props
        const { isOpen } = this.state

        if (headerOpen && isOpen) {
            return headerOpen
        }

        return header
    }

    render() {
        const {
            icon,
            bold,
            children,
            disabled,
            isOpen: isOpenProps,
            changeVisibility,
            onlyLeftChevron,
            color,
            loading,
            inTable,
            noAnimation,
            noMargin,
        } = this.props
        const { maxHeightBody, isOpen: isOpenState } = this.state
        let isOpen = isOpenState
        if (changeVisibility) isOpen = isOpenProps

        return (
            <ExpanderDom inTable={inTable} noMargin={noMargin}>
                <Header bold={bold} onClick={this.changeVisibility} disabled={disabled} color={color}>
                    {icon && !onlyLeftChevron && (
                        <IconWrapper isOpen={isOpen} marginRight="5px">
                            <Icon icon={icon} />
                        </IconWrapper>
                    )}
                    {!onlyLeftChevron && this.renderHeader()}
                    <IconWrapper marginLeft="5px" marginRight="5px" size="10px" isOpen={isOpen} rotateAnimation loading={loading}>
                        {loading ? <Icon icon="spinner" pulse /> : <Icon icon="chevron-right" />}
                    </IconWrapper>
                    {onlyLeftChevron && this.renderHeader()}
                </Header>
                <Body
                    ref={(node) => this.saveChildElement(node)}
                    isOpen={isOpen}
                    maxHeightBody={maxHeightBody}
                    noAnimation={noAnimation}
                    onClick={(e) => typeof e.stopPropagation === 'function' && e.stopPropagation()}
                >
                    {children}
                </Body>
            </ExpanderDom>
        )
    }
}

export default ExpanderComponent
